module.exports = __webpack_public_path__ + "img/chart-simple-horizontal.33eb7400.svg";